import { useFeatureFlag } from '@application/feature_flags/use_feature_flag';
import { BreakPoints, useBreakpoint } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Footer } from '@component/footer';
import { HEADER_HEIGHT, Header, REPRESENTATION_BANNER_HEIGHT } from '@component/header.component';
import { TabBar } from '@component/tab_bar.component';
import { useRepresentablePatients } from '@feature/representation/use-representable-patients';
import { Outlet } from 'react-router';
import styled from 'styled-components';

export function LayoutOutletWithHeader() {
	const breakpoint = useBreakpoint();
	const featureUseRepresentatives = useFeatureFlag('PatientWeb.UseRepresentatives');
	const { currentlyRepresentedPatient } = useRepresentablePatients({ enabled: featureUseRepresentatives });

	return (
		<>
			<StyledContainer $hasRepresentationBanner={currentlyRepresentedPatient != null}>
				<Header />
				{breakpoint === BreakPoints.Small ? <TabBar /> : null}
				<StyledMain>
					<Outlet />
				</StyledMain>
				<Footer />
			</StyledContainer>
		</>
	);
}

const StyledContainer = styled.div<{ $hasRepresentationBanner: boolean }>`
	padding-top: calc(${HEADER_HEIGHT.small} + ${({ $hasRepresentationBanner }) => ($hasRepresentationBanner ? REPRESENTATION_BANNER_HEIGHT : '0px')});
	padding-bottom: 66px;

	${tokens.breakpointQuery.medium} {
		padding-top: calc(${HEADER_HEIGHT.medium} + ${({ $hasRepresentationBanner }) => ($hasRepresentationBanner ? REPRESENTATION_BANNER_HEIGHT : '0px')});
		padding-bottom: 0;
	}
`;

const StyledMain = styled.main`
	min-height: calc(100vh - 150px);
`;
